import {
  Component,
} from "react";
import uiconfig from "CommonState/uiconfig";
import AntragHistorieWidget from "App/antrag-historie-widget";
import antragApi from "Apis/antrag-api";
import {
  Spinner,
} from "CommonComponents/bricks";

@uiconfig
@antragApi.current
export default class AntragHistorieTab extends Component {
  render() {
    const { currentAntrag } = this.props;
    if (!currentAntrag) {
      return <Spinner />;
    }
    return <div>
      <AntragHistorieWidget antrag={ currentAntrag } />
    </div>;
  }
}
